module.exports = __webpack_public_path__ + "static/img/sec2-img06@m.aaecdaa.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/transys/sec2-img06@m.png
// module id = /1pB
// module chunks = 0